// extracted by mini-css-extract-plugin
export default {"actions":"UiModalConfirm_actions_OC4F6","reject":"UiModalConfirm_reject_XPIC5"};